/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_No_WorkoutsInputs */

const en_us2_coaching_no_workouts = /** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workouts in the last 60 days.`)
};

const pt_br2_coaching_no_workouts = /** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino nos últimos 60 dias.`)
};

const pt_pt2_coaching_no_workouts = /** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino nos últimos 60 dias.`)
};

/** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */
const es_419_coaching_no_workouts = en_us2_coaching_no_workouts;

/** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */
const fr_fr2_coaching_no_workouts = en_us2_coaching_no_workouts;

/** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */
const de_de2_coaching_no_workouts = en_us2_coaching_no_workouts;

/** @type {(inputs: Coaching_No_WorkoutsInputs) => LocalizedString} */
const it_it2_coaching_no_workouts = en_us2_coaching_no_workouts;

/**
* | output |
* | --- |
* | "No workouts in the last 60 days." |
*
* @param {Coaching_No_WorkoutsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_no_workouts = /** @type {((inputs?: Coaching_No_WorkoutsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_No_WorkoutsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_no_workouts(inputs)
	if (locale === "es-419") return es_419_coaching_no_workouts(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_no_workouts(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_no_workouts(inputs)
	if (locale === "de-DE") return de_de2_coaching_no_workouts(inputs)
	if (locale === "it-IT") return it_it2_coaching_no_workouts(inputs)
	return en_us2_coaching_no_workouts(inputs)
});
export { coaching_no_workouts as "coaching.no_workouts" }